module.exports = __webpack_public_path__ + "static/media/image-eighth-strip.ad138233.svg";